module.exports = function() {
  return new Worker(__webpack_public_path__ + "24b3eaa6531ae97d1c8e.worker.js");
};